'use client';

import posthog from 'posthog-js';
import { useLayoutEffect } from 'react';
import {
  getOrCreateSchedulerRunId,
  SCHEDULER_RUN_COOKIE,
} from '@/util/scheduling/schedulerRun';

/**
 * One run id per tab session for online `/scheduler` and internal `/schedule` (→ `tools/schedule`).
 * Sets client telemetry context + cookie so server actions and API proxy forward `x-attik-scheduler-run-id`.
 */
export default function SchedulerRunProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useLayoutEffect(() => {
    const id = getOrCreateSchedulerRunId();
    if (!id) return;
    posthog.register({ scheduler_run_id: id });
    const secure =
      typeof window !== 'undefined' && window.location.protocol === 'https:';
    document.cookie = `${SCHEDULER_RUN_COOKIE}=${encodeURIComponent(id)}; path=/; max-age=86400; SameSite=Lax${secure ? '; Secure' : ''}`;
  }, []);
  return <>{children}</>;
}
